// @flow
import * as React from "react"
import type { HOC, Component } from "recompose"
import withUser from "hoc/withUser"
import ModalBody from "modals/_Body"
import ModalContent from "modals/_Content"
import ModalControls from "modals/_Controls"
import { Wrap } from "componentsStyled/Layout/Wrap"
import Button from "components/Button"
import { PageTitle } from "componentsStyled/Typography/Titles"
import { Text } from "componentsStyled/Typography/Texts"
import { ReservationSuccessWrap } from "./styled"
import SuccessIcon from "./SuccessIcon"

const ReservationSuccess = ({ close, user, component }) => (
  <ModalBody close={close}>
    <ModalContent>
      <Wrap>
        <ReservationSuccessWrap>
          <SuccessIcon />
          {component ? (
            component
          ) : (
            <div>
              <PageTitle>Congrats!</PageTitle>
              <Text book black center lh={2}>
                You're ready to go
              </Text>
              <Text center>
                You won’t be charged if you cancel your reservation up to{" "}
                {user.subscribed ? 24 : 48} hours in advance
              </Text>
            </div>
          )}
        </ReservationSuccessWrap>
      </Wrap>
    </ModalContent>
    <ModalControls>
      <Button fullwidth onClick={close}>
        View Reservation
      </Button>
    </ModalControls>
  </ModalBody>
)

type Outter = {|
  close: Function,
  component?: Component,
|}

const enhancer: HOC<*, Outter> = withUser()

export default enhancer(ReservationSuccess)



// WEBPACK FOOTER //
// ./src/modals/ReservationSuccess/index.js